import React, { useState } from 'react';

import { Link } from 'react-router-dom';

import Icon from 'components/common/Icons/base/Icon/Icon';
import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';

import { IProject } from 'components/Dashboards/Portfolio/phasePerformance/manage/manage.types';
import { SingleProject } from 'components/Dashboards/Portfolio/phasePerformance/manage/singleTemplateComponent/templateProjectsComponent/singleProject/singleProject';
import { portfolioConfig } from 'components/Dashboards/Portfolio/portfolioConfig';
import Button from 'components/DesignSystem/Button/Button';
import { TextInput } from 'components/DesignSystem/TextInput/TextInput';
import { CustomizedTooltip } from 'components/common';

import classes from './templateProjectsComponent.module.scss';

export const TemplateProjectsComponent = ({ projects, templateId }: { projects: IProject[]; templateId: number }) => {
    const [searchValue, setSearchValue] = useState<string>('');
    const [searchWord, setSearchWord] = useState<string>('');

    const handleSearchInputChange = (e) => {
        setSearchValue(e.target.value);
    };

    const handleOnSearch = () => {
        setSearchWord(searchValue);
    };

    const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.code === 'Enter' || e.code === 'NumpadEnter') {
            handleOnSearch();
        }
    };

    const mappedProjects =
        searchWord.length > 0
            ? projects.filter((item) => item.project_name.toLowerCase().includes(searchWord.toLowerCase()))
            : projects;

    return (
        <div data-testid={'template-project-container'} className={classes.templateProjectsContainer}>
            <div className={classes.title}>Template Mappings</div>
            <div data-testid={'template-top-content'} className={classes.topContent}>
                <div className={classes.searchInputContainer}>
                    <TextInput
                        placeholder={'Search Existing Mappings...'}
                        value={searchValue}
                        onChange={handleSearchInputChange}
                        onClear={(e) => {
                            setSearchValue('');
                            setSearchWord('');
                            e.stopPropagation();
                        }}
                        onKeyDown={onKeyDown}
                        searchable={true}
                        onSearch={handleOnSearch}
                    />
                </div>
                <Link
                    className={classes.linkStyle}
                    to={`${portfolioConfig.phasePerformanceManage.link}/${portfolioConfig.phasePerformanceManageMapProject.link}?templateId=${templateId}`}
                >
                    <CustomizedTooltip
                        tooltipContent={'Add Mapping'}
                        triggerElement={
                            <Button variant={'primary'}>
                                <MuiIcon icon={'add'} color={'var(--button-primary-fg)'} />
                            </Button>
                        }
                    />
                </Link>
            </div>
            <div data-testid={'template-project-wrapper'} className={classes.projectsWrapper}>
                {mappedProjects.map((item, index) => (
                    <SingleProject key={index} project={item} templateId={templateId} />
                ))}
            </div>
        </div>
    );
};
